import { PublicServerPlaceEvent } from 'gleblu-socket-api';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { forgotPassword, forgotPasswordFailed, ForgotPasswordPayload, resetLinkSent } from '../../actions/user/forgotPassword';
import getPublicResponse from '../getPublicResponse';

function* forgotPasswordSaga({ payload }: Action<ForgotPasswordPayload>) {
  const { email } = payload;
  const response = yield getPublicResponse(PublicServerPlaceEvent.forgotPassword, {
    email,
  });
  if (!response.error && !response.errorType) {
    yield put(resetLinkSent({}));
  } else {
    yield put(forgotPasswordFailed({ errorType: response.errorType }));
  }
}

export default function* watchForgotPasswordSaga() {
  yield takeEvery(forgotPassword, forgotPasswordSaga);
}
